import { render, staticRenderFns } from "./CreditRuleList.vue?vue&type=template&id=e8736934&"
import script from "./CreditRuleList.vue?vue&type=script&lang=js&"
export * from "./CreditRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports